<!-- Bell -->
<button class="nb-trigger" (click)="toggleSidebar()">
  <mat-icon fontSet="material-icons-outlined">notifications</mat-icon>
  @if (messagesService.unreadMessagesCount$ | async; as count) {
    <span class="nb-badge"
      >
      {{ count }}
    </span>
  }
</button>

<!-- Backdrop -->
@if (isOpen) {
  <div class="nb-overlay" (click)="close()"></div>
}

<!-- Panel -->
<div class="nb-panel" [class.open]="isOpen">

  <!-- Header -->
  <div class="nb-header">
    <div class="nb-header-top">

      <div class="nb-header-right">
        <div class="nb-bell-icon">
          <mat-icon fontSet="material-icons-outlined">notifications</mat-icon>
        </div>
        <div>
          <p class="nb-title">{{ 'notification_label.label.notification' | translate }}</p>
          <p class="nb-subtitle">
            {{ (messagesService.unreadMessagesCount$ | async) || 0 }}
            {{ 'notification_label.label.newSinceLastVisit' | translate }}
          </p>
        </div>
      </div>

      <div class="nb-header-left">
        <button class="nb-mark-all" (click)="markAllRead()">
          <mat-icon style="font-size:14px;width:14px;height:14px">done_all</mat-icon>
          {{ 'notification_label.label.markAllRead' | translate }}
        </button>
        <button aria-label="סגירה" class="nb-close" (click)="close()">
          <mat-icon>close</mat-icon>
        </button>
      </div>

    </div>

    <!-- Tabs -->
    <div class="nb-tabs">
      <button class="nb-tab" [class.active]="selectedTab === 0" (click)="selectedTab = 0">
        {{ 'notification_label.label.all' | translate }}
        <span class="nb-tab-count">{{ (messagesService.messages$ | async)?.length || 0 }}</span>
      </button>
      <button class="nb-tab" [class.active]="selectedTab === 1" (click)="selectedTab = 1">
        {{ 'notification_label.label.unread' | translate }}
        @if ((messagesService.unreadMessagesCount$ | async); as u) {
          <span class="nb-tab-count warning"
          >{{ u }}</span>
        }
      </button>
      <button class="nb-tab" [class.active]="selectedTab === 2" (click)="selectedTab = 2">
        {{ 'notification_label.label.flagged' | translate }}
      </button>
    </div>
  </div>

  <!-- Search -->
  <div class="nb-search-wrap">
    <div class="nb-search">
      <mat-icon fontSet="material-icons-outlined">search</mat-icon>
      <input [(ngModel)]="searchQuery"
        [placeholder]="'notification_label.label.searchNotifications' | translate" />
      </div>
    </div>

    <!-- List -->
    @if (messagesService.messages$ | async; as all) {
      @if (filteredNotifications(all).length) {
        <div class="nb-list">
          <!-- Today -->
          @if (todayGroup(filteredNotifications(all)); as today) {
            @if (today.length) {
              <div class="nb-group-label">
                {{ 'notification_label.label.today' | translate }}
              </div>
            }
            @for (n of today; track n) {
              <ng-container *ngTemplateOutlet="notifCard; context: { $implicit: n }"></ng-container>
            }
          }
          <!-- Earlier -->
          @if (earlierGroup(filteredNotifications(all)); as earlier) {
            @if (earlier.length) {
              <div class="nb-group-label" style="margin-top:4px">
                {{ 'notification_label.label.earlier' | translate }}
              </div>
            }
            @for (n of earlier; track n) {
              <ng-container *ngTemplateOutlet="notifCard; context: { $implicit: n }"></ng-container>
            }
          }
        </div>
      } @else {
        <div class="nb-empty">
          <mat-icon fontSet="material-icons-outlined">notifications_none</mat-icon>
          <p class="nb-empty-title">{{ 'notification_label.label.allCaughtUp' | translate }}</p>
          <p class="nb-empty-sub">{{ 'notification_label.label.noNotifications' | translate }}</p>
        </div>
      }
    }

    <!-- Footer -->
    <div class="nb-footer">
      <span class="nb-footer-note">
        {{ 'notification_label.label.showing' | translate }}
        {{ (messagesService.messages$ | async)?.length || 0 }}
        {{ 'notification_label.label.notifications' | translate }}
      </span>
      <button class="nb-view-all">
        {{ 'notification_label.label.viewAll' | translate }} ←
      </button>
    </div>

  </div>

  <!-- ── Reusable card template ── -->
  <ng-template #notifCard let-n>
    <div class="nb-item"
      [class.unread]="!n.is_read"
      (click)="markAsRead(n)">

      @if (!n.is_read) {
        <span class="nb-unread-dot"></span>
      }

      <div class="nb-avatar-col">
        <img class="nb-avatar"
          [src]="n.image || 'assets/images/default-avatar.png'"
          [alt]="n.subject" />
          @if (n.notification_type) {
            <div class="nb-type-badge">
              <mat-icon>inventory_2</mat-icon>
            </div>
          }
        </div>

        <div class="nb-body">
          <div class="nb-row-top">
            <span class="nb-name">{{ n.subject }}</span>
            <div class="nb-meta">
              <button aria-label="סימון התראה" class="nb-flag"
                [class.active]="n.flag"
                (click)="toggleFlag(n, $event)">
                <mat-icon>{{ n.flag ? 'flag' : 'outlined_flag' }}</mat-icon>
              </button>
              <span class="nb-time">
                {{ CustomDateUtils.timeAgo(n.timestamp, translate) }}
              </span>
            </div>
          </div>

          <div class="nb-chip-row">
            @if (n.notification_type) {
              <span class="nb-chip product">
                {{ n.notification_type }}
              </span>
            }
            @if (n.flag) {
              <span class="nb-chip flagged">
                {{ 'notification_label.label.flagged' | translate }}
              </span>
            }
          </div>

          <p class="nb-message">{{ n.message }}</p>

          @if (!n.is_read) {
            <div class="nb-actions-row">
              <button class="nb-action primary"
                (click)="markAsRead(n); $event.stopPropagation()">
                {{ 'notification_label.label.viewDetails' | translate }}
              </button>
              <button class="nb-action" (click)="$event.stopPropagation()">
                {{ 'notification_label.label.dismiss' | translate }}
              </button>
            </div>
          }
        </div>

      </div>
    </ng-template>